import Vue from 'vue'
import Resource from 'vue-resource'
import store from '@/store'
Vue.use(Resource)

export default {
	findAll (params = {}) {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/notifications', {
				params: params
			}).then(function (response) {
				resolve(response)
			}, function (response) {
				reject(response)
			})
		})
	},
	/**
	 * @param {number} id
	 * @param {object} params
	 */
	findOne (id, params = {}) {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/notifications/' + id, {
				params: params
			}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	},
	create (data) {
		return new Promise(function (resolve, reject) {
			Vue.http.post(store.state.apiURL + '/v1/notifications', data).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	},
	update (id, data) {
		return new Promise(function (resolve, reject) {
			Vue.http.put(store.state.apiURL + '/v1/notifications/' + id, data).then(function (response) {
				resolve(response)
			}, function (response) {
				reject(response)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/notification/notification.js